export default __webpack_public_path__ + "static/media/example-profile-photo-1.4f902382.png";